import { render, staticRenderFns } from "./SpaceBoosters.vue?vue&type=template&id=a3213038"
import script from "./SpaceBoosters.vue?vue&type=script&lang=js"
export * from "./SpaceBoosters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports